export default __webpack_public_path__ + "static/media/icon_endtype_FlushEnd.3f397f3f.png";